import { Button } from 'antd'
import { AppstoreOutlined, CheckOutlined, FileTextOutlined, UserOutlined } from '@ant-design/icons'
import { AUTH_PRIMARY_BUTTON_CLASS } from '../../constants'
import { useSignup } from '../SignupContext'

const NEXT_STEPS = [
  {
    icon: <AppstoreOutlined />,
    title: 'Connect your first Xero organisation',
    description: 'Head to Integrations → Add new Platform. Takes about 30 seconds.',
  },
  {
    icon: <UserOutlined />,
    title: 'Set up your avatar and voice',
    description: 'Under AdvicePrep → Settings. Required for the Video Avatar Summary export.',
  },
  {
    icon: <FileTextOutlined />,
    title: 'Take the 90-second tour',
    description: 'Preppy (bottom-right in AdvicePrep) will offer to show you around on your first visit.',
  },
]

export default function AdvicePrepSuccessStep() {
  const { customerForm, finalizeSignup, loading } = useSignup()

  return (
    <>
      <div className="py-[1.25rem] text-center">
        <div className="mb-[0.875rem] inline-grid h-[4rem] w-[4rem] place-items-center rounded-full bg-brand-500 text-[2rem] text-white">
          <CheckOutlined />
        </div>
        <h4 className="mb-[0.375rem] font-display text-[1.25rem] font-bold text-gray-900">Welcome to AdvicePrep!</h4>
        <p className="mx-auto max-w-[21.25rem] text-[0.84375rem] leading-[1.6] text-gray-600">
          Your account is set up and your subscription has started. A receipt is on its way to{' '}
          <strong>{customerForm?.email || 'your email'}</strong>.
        </p>
      </div>

      <div className="mt-[1.25rem] flex flex-col gap-[0.5rem]">
        {NEXT_STEPS.map((item) => (
          <div key={item.title} className="flex gap-[0.75rem] rounded-[0.5rem] border border-gray-200 p-[0.75rem]">
            <div className="grid h-[2rem] w-[2rem] shrink-0 place-items-center rounded-[0.5rem] bg-brand-50 text-brand-700">
              {item.icon}
            </div>
            <div className="min-w-0">
              <div className="text-[0.8125rem] font-semibold text-gray-900">{item.title}</div>
              <div className="mt-[0.0625rem] text-[0.75rem] leading-[1.5] text-gray-600">{item.description}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="signup-step-actions">
        <Button
          type="primary"
          loading={loading}
          disabled={loading}
          className={AUTH_PRIMARY_BUTTON_CLASS}
          onClick={() => void finalizeSignup()}
        >
          Take me into AdvicePrep
        </Button>
      </div>
    </>
  )
}
